var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorInYellowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3335 17H18.6668C16.8285 17 15.3335 18.495 15.3335 20.3333V38.6667C15.3335 40.505 16.8285 42 18.6668 42H30.3335V45.3333H25.3335V48.6667H38.6668V45.3333H33.6668V42H45.3335C47.1718 42 48.6668 40.505 48.6668 38.6667V20.3333C48.6668 18.495 47.1718 17 45.3335 17ZM18.6668 35.3333V20.3333H45.3335L45.3368 35.3333H18.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorInYellowCircle);
export default __webpack_public_path__ + "static/media/monitor-in-yellow-circle.8c6d6e0b6c7f86fc149d70f59d0c3791.svg";
export { ForwardRef as ReactComponent };